import { addSlidesTabIndex } from '@gravity-global/helpers/swiper/add-slides-tab-index';

const dynamicSliderInit = () => {
  const mainPattern = document.querySelectorAll('.gg-quotes-slider');

  mainPattern.forEach((module) => {
    const swipers = module.querySelector('.wp-block-statik-slider__slides-container');
    const swiperWrapper = module.querySelector('.wp-block-statik-slider__slides');

    if (!swipers || !swiperWrapper) {
      return;
    }

    const swiperSlides = module.querySelectorAll('.wp-block-statik-slider__slide');
    const swiperNext = module.querySelector(
      '.wp-block-statik-slider__direction-nav > .wp-block-statik-slider__direction-nav-button:first-child',
    );
    const swiperPrev = module.querySelector(
      '.wp-block-statik-slider__direction-nav > .wp-block-statik-slider__direction-nav-button:last-child',
    );
    
    if (swiperPrev) swiperPrev.setAttribute('rel', 'prev');
    if (swiperNext) swiperNext.setAttribute('rel', 'next');

    swipers.classList.add('swiper-container');
    swiperWrapper.classList.add('swiper-wrapper');
    swiperSlides.forEach((slide) => {
      slide.classList.add('swiper-slide');
    });

    const carousel = new window.Swiper(swipers, {
      loop: true,
      centeredSlides: true,
      slidesPerView: 1,
      allowTouchMove: true,
      navigation: {
        prevEl: swiperPrev,
        nextEl: swiperNext,
      },
      on: {
        init: (swiper) => addSlidesTabIndex(swiper),
        slideChange: (swiper) => addSlidesTabIndex(swiper),
      },
    });
    carousel.init();
  });
};
dynamicSliderInit();
